
    export enum EnumMiniCrmFollowUpType {
			Reached = 2,
			CallAgainIn = 3,
			EmailAgainIn = 4,
    }